// extracted by mini-css-extract-plugin
export default {"sectionDescription":"Services_sectionDescription__2zQg2","item":"Services_item__Sf++2","imageItem":"Services_imageItem__v98RZ"};